export function formatProjectDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  try {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "numeric",
      hour12: true,
    }).formatToParts(d);
    const get = (type) => parts.find((p) => p.type === type)?.value || "";
    const meridiem = get("dayPeriod").toUpperCase();
    return `${get("day")}-${get("month")}-${get("year")} ${meridiem}`.trim();
  } catch {
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hours = d.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    return `${day}-${month}-${year} ${ampm}`;
  }
}

export function mapApiProject(p) {
  const wabaId = String(p.waba_id || p.wabaId || "").trim();
  const owner = p.owner || null;
  return {
    id: p._id,
    name: p.projectname || p.display_name || "Untitled Project",
    apiNumber: p.contact || "—",
    createdAt: formatProjectDate(p.createdAt),
    activePlan: p.planName || "—",
    bluetick: p.bluetickverified ? "Verified" : "Not verified",
    bluetickVerified: Boolean(p.bluetickverified),
    wabaId: wabaId || null,
    waConnected: Boolean(wabaId),
    owner: owner
      ? {
          id: owner._id || owner.id || "",
          name: owner.name || owner.email || "User",
          email: owner.email || "",
          type: owner.type || "admin",
        }
      : null,
  };
}

export function mapProjectsByUser(groups = []) {
  return (Array.isArray(groups) ? groups : []).map((group) => ({
    user: {
      id: group?.user?._id || group?.user?.id || "",
      name: group?.user?.name || group?.user?.email || "User",
      email: group?.user?.email || "",
      type: group?.user?.type || "admin",
    },
    projects: (group?.projects || []).map(mapApiProject),
  }));
}
